import { render, staticRenderFns } from "./500.vue?vue&type=template&id=4cf39caa&scoped=true&"
import script from "./500.vue?vue&type=script&lang=js&"
export * from "./500.vue?vue&type=script&lang=js&"
import style0 from "./500.vue?vue&type=style&index=0&id=4cf39caa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf39caa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cf39caa')) {
      api.createRecord('4cf39caa', component.options)
    } else {
      api.reload('4cf39caa', component.options)
    }
    module.hot.accept("./500.vue?vue&type=template&id=4cf39caa&scoped=true&", function () {
      api.rerender('4cf39caa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/error-page/500.vue"
export default component.exports